export const formatAddressBlock = (address) => {
  if (!address) return [];
  const lines = [
    address.FullName ?? address.fullName,
    address.MobileNumber ?? address.mobileNumber,
    address.AddressLine1 ?? address.addressLine1,
    address.AddressLine2 ?? address.addressLine2,
    address.Landmark ?? address.landmark,
    [
      address.City ?? address.city,
      address.State ?? address.state,
      address.PostalCode ?? address.postalCode,
    ].filter(Boolean).join(', '),
    address.Country ?? address.country,
  ].filter((line) => String(line || '').trim());
  return lines;
};

export const normalizeAddress = (row) => ({
  addressId: row?.AddressId ?? row?.addressId,
  userId: row?.UserId ?? row?.userId,
  fullName: row?.FullName ?? row?.fullName ?? '',
  mobileNumber: row?.MobileNumber ?? row?.mobileNumber ?? '',
  addressLine1: row?.AddressLine1 ?? row?.addressLine1 ?? '',
  addressLine2: row?.AddressLine2 ?? row?.addressLine2 ?? '',
  landmark: row?.Landmark ?? row?.landmark ?? '',
  city: row?.City ?? row?.city ?? '',
  state: row?.State ?? row?.state ?? '',
  country: row?.Country ?? row?.country ?? '',
  postalCode: row?.PostalCode ?? row?.postalCode ?? '',
  addressType: row?.AddressType ?? row?.addressType ?? '',
  isDefault: row?.IsDefault ?? row?.isDefault ?? false,
});
